import styled from 'styled-components';
import { PrimaryColor, GreySidely, SurfaceColor } from '../../../styles/global/css/Utils';

interface SwitchProps {
  isActive: boolean
  size: string
}

const Container = styled.div<SwitchProps>`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    min-width: calc(2 * ${p => p.size} + 2px);
    max-width: calc(2 * ${p => p.size} + 2px);
    min-height: calc(${p => p.size} + 4px);
    max-height: calc(${p => p.size} + 4px);
    padding: 2px;
    margin-top: 2px;
    transition-duration: 300ms;
    transition-property: border background-color;
    border-radius: 500px;
    background-color: ${p => p.isActive ? PrimaryColor : GreySidely};
    border: 1px solid ${p => p.isActive ? PrimaryColor : GreySidely};
    cursor: pointer;
`;

const Round = styled.div<SwitchProps>`
    flex-shrink: 0;
    transition-duration: 300ms;
    transition-property: background-color margin-left;
    background-color: ${SurfaceColor};
    border-radius: 50%;
    width: calc(${p => p.size} - 2px);
    height: calc(${p => p.size} - 2px);
    margin-left: calc(${p => p.isActive ? `100% - ${p.size} + 2px` : '0px'});
`;

export {
	Container,
	Round
};
